import { z } from 'zod';
import type { Layout } from '@kioskforge/shared';
import type { PresetDefinition } from './types';

/**
 * A5b.7 — one visitor-form field. `required` defaults false and `type` defaults
 * `text` so a minimal `{id,label}` entry is still valid (the server's
 * `compilePreset` applies the same defaults). `fields` is optional so a config
 * written before this key existed still compiles to the skeleton's one field.
 */
export const formFieldSchema = z.object({
  id: z.string().min(1),
  label: z.string().min(1),
  type: z.enum(['text', 'email', 'phone', 'select', 'host']).default('text'),
  required: z.boolean().default(false),
  options: z.array(z.string()).optional()
});

const config_schema = z.object({
  title: z.string().min(1),
  form_id: z.string().min(1),
  consent_text: z.string().max(2000),
  fields: z.array(formFieldSchema).optional()
});
const layout = {
  version: 1 as const, grid: { cols: 4, rows: 4 }, home: 'welcome',
  screens: [
    { id: 'welcome', name: 'Welcome', blocks: [
      { id: 'greeting', type: 'text' as const, rect: { x: 0, y: 0, w: 4, h: 2 }, props: { text: '{data.title}', size: 'xl' as const, align: 'center' as const, weight: 'bold' as const } },
      { id: 'continue', type: 'buttons' as const, rect: { x: 1, y: 2, w: 2, h: 2 }, props: { layout: 'column' as const, buttons: [{ id: 'start', label: 'Check in', action: { type: 'goto_screen' as const, screen_id: 'details' } }] } }
    ] },
    { id: 'details', name: 'Visitor details', blocks: [
      { id: 'form', type: 'form' as const, rect: { x: 0, y: 0, w: 4, h: 3 }, props: { form_id: 'visitor', submit_label: 'Continue', fields: [{ id: 'name', label: 'Your name', type: 'text' as const, required: true }] } },
      { id: 'consent', type: 'consent' as const, rect: { x: 0, y: 3, w: 4, h: 1 }, props: { text: 'Please read the visitor information.', checkbox_label: 'I agree' } }
    ] }
  ]
} satisfies Layout;

export const checkin: PresetDefinition<typeof config_schema> = {
  key: 'checkin', sector: 'Check-in & Self-Service', wave: 1, name: 'Visitor check-in',
  min_lockdown: 'pwa', device_classes: ['tablet'], config_schema, layout
};